import { useState } from 'react';
import { History, ChevronDown, ChevronUp, CheckCircle2, XCircle, Upload, RotateCcw } from 'lucide-react';

const EVENT_META = {
  submitted: { label: 'Submitted', Icon: Upload, color: 'text-muted-foreground' },
  resubmitted: { label: 'Resubmitted', Icon: RotateCcw, color: 'text-forest' },
  approved: { label: 'Approved', Icon: CheckCircle2, color: 'text-green-600' },
  rejected: { label: 'Rejected', Icon: XCircle, color: 'text-red-600' },
  pending: { label: 'Pending review', Icon: Upload, color: 'text-amber-600' },
};

const fmt = (iso) => {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleString('en-ZA', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
  } catch {
    return iso;
  }
};

const DocumentHistory = ({ history, testIdPrefix = 'doc' }) => {
  const [open, setOpen] = useState(false);
  const events = Array.isArray(history) ? history : [];
  if (events.length === 0) return null;

  return (
    <div className="mt-2 pl-6">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground"
        data-testid={`${testIdPrefix}-history-toggle`}
      >
        <History className="w-3.5 h-3.5" />
        {open ? 'Hide history' : `View history (${events.length})`}
        {open ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />}
      </button>
      {open && (
        <ol className="mt-2 space-y-2 border-l border-border pl-3" data-testid={`${testIdPrefix}-history-list`}>
          {events.map((ev, i) => {
            const meta = EVENT_META[ev.type] || EVENT_META.submitted;
            const { Icon } = meta;
            return (
              <li key={i} className="text-xs">
                <div className="flex items-center gap-1.5">
                  <Icon className={`w-3.5 h-3.5 ${meta.color}`} />
                  <span className="font-medium text-foreground">{meta.label}</span>
                  <span className="text-muted-foreground">· {fmt(ev.at)}</span>
                </div>
                {ev.reason && (
                  <p className="text-red-700 mt-0.5 ml-5"><span className="font-medium">Reason:</span> {ev.reason}</p>
                )}
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
};

export default DocumentHistory;
